// @flow
import React, { Component } from 'react'
import './style.css'
import Contrato_1A from '../Assets/Files/1A.pdf'
import Contrato_1B from '../Assets/Files/1B.pdf'
import Contrato_1C from '../Assets/Files/1C.pdf'
import Contrato_1D from '../Assets/Files/1D.pdf'
import Contrato_2A from '../Assets/Files/2A.pdf'
import Contrato_2B from '../Assets/Files/2B.pdf'
import Contrato_2C from '../Assets/Files/2C.pdf'
import Estatuo from '../Assets/Files/ESTATUTO.pdf'

export default class Termns extends Component {
  render () {
    return (
      <body>
        <div className='box'>
          <h2>
            Contratos, Términos y Condiciones, Estatuo de Coopenae y Leyes
            Complementarias
          </h2>
          <h5>Estos documentos los puedes descargar o imprimir.</h5>
          <ul>
            <li>
              <a href={Contrato_1A} target='_blank'>
                Contrato de afiliacion a la plataforma Wink.
              </a>
            </li>
            <li>
              <a href={Contrato_1B} target='_blank'>
                Contrato de apertura de cuentas por medio de la plataforma Wink.
              </a>
            </li>
            <li>
              <a href={Contrato_1D} target='_blank'>
                Contrato para Uso del Servicio de Transferencias PayPal en la
                Plataforma de Conectividad Wink.
              </a>
            </li>
            <li>
              <a href={Contrato_2A} target='_blank'>
                Terminos y Condiciones para uso de la pataforma Wink.
              </a>
            </li>
            <li>
              <a href={Contrato_2B} target='_blank'>
                Consentimiento Informado en la plataforma Wink.
              </a>
            </li>
            <li>
              <a href={Contrato_2C} target='_blank'>
                Consentimiento Informado para la afiliacion en la plataforma Wink
              </a>
            </li>
          </ul>
          <div className='box'>
            <h4>Otros documentos complementarios:</h4>

            <ul>
              <li>
                <a href={Estatuo} target='_blank'>
                  Estatuto de Coopenae R.L.
                </a>
              </li>
              <li>
                <a
                  href={
                    'http://www.pgrweb.go.cr/scij/Busqueda/Normativa/Normas/nrm_texto_completo.aspx?nValor1=1&nValor2=32655'
                  }
                  target='_blank'
                >
                  Ley de Asociaciones Cooperativas (Ley 4179).
                </a>
              </li>
              <li>
                <a
                  href={
                    'http://www.pgrweb.go.cr/scij/Busqueda/Normativa/Normas/nrm_texto_completo.aspx?nValor1=1&nValor2=11935'
                  }
                  target='_blank'
                >
                  Ley de Regulación de la Actividad Financiera de la
                  Organizaciones Cooperativas.
                </a>
              </li>
            </ul>
          </div>
          <div className='central'>
            <div className='div1'>
              <a href='http://www.coopenae.fi.cr/'>
                Conocé más acerca
                <br />
                de Coopenae R.L.
              </a>
            </div>
            <div className='div1' style={{ marginLeft: '1.5vh' }}>
              <a href='http://www.holawink.com/'>
                Conocé más acerca
                <br />
                de Wink
              </a>
            </div>
          </div>
        </div>
      </body>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/TermnsConditions/index.js